export default __webpack_public_path__ + "static/media/pj-node-redis.e6a2d917.png";